import { EnvelopeSimpleIcon } from "@phosphor-icons/react";
import { Link, useSearchParams } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4">
      <Card variant="box" className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="bg-accent/10 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            <EnvelopeSimpleIcon className="text-accent h-8 w-8" />
          </div>
          <p className="text-muted t-eyebrow">Verification</p>
          <CardTitle className="font-heading text-foreground text-4xl font-normal tracking-[-0.01em]">
            Check your email
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-muted mb-6">
            We&apos;ve sent a verification link to{" "}
            {email ? (
              <span className="text-foreground font-medium">{email}</span>
            ) : (
              "your email address"
            )}
            . Confirm your address to unlock the workflow workspace.
          </p>
          <p className="text-muted mb-6 text-sm">
            Didn&apos;t receive it? Check spam, then request another invite if needed.
          </p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">Back to sign in</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
